import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../utils";
const Skeleton = ({ className, width, height, children, ...props }) => {
    return (_jsx("div", { "data-testid": "skeleton", style: { width, height }, className: cn("animate-pulse rounded-md bg-gray-5", className), ...props, children: children }));
};
export default Skeleton;
